import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { CartService } from 'src/app/services/dhukan/cart.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { OrdersdetailsComponent } from '../ordersdetails/ordersdetails.component';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent implements OnInit {

  cartBO:any={};
  cartColl:any=[];
  cartView:any={};


  customerBO:any={};   
  customerOrderMainColl:any=[];
  customerOrderDetailsColl:any=[];

  customerView:any={};

  _selecttabset: string = "";

  _ordertype:any="ACTIVE";

  _routerCustomerSub = Subscription.EMPTY;
  
  @Output() emitData = new EventEmitter();
  
  constructor(private loginservice: LoginDataService,private cartservice:CartService,private modelService: NgbModal, public router: Router,public activeModal: NgbActiveModal) {
    this.fnServiceChanges();
   }

   fnServiceChanges(){
      
    this.customerView = this.loginservice.customerView; 
    this._routerCustomerSub= this.loginservice.servicecustomerChange.subscribe((value) => {
        this.customerView = value        
        if(this.customerView.customermain){                
          this.customerBO= this.customerView.customermain;                
          this.fnGetOrder(this._ordertype);
        }      

    }); 

 

  }
  

  ngOnInit(): void {
    try{
      this.customerView = this.loginservice.customerView
      if (this.customerView.customermain) {
        this.customerBO = this.customerView.customermain
      }
      this.fnGetOrder(this._ordertype);
      
    }catch(ex){
      this.fnShowErrorMsg('Internal Error'+ex);
    }
  }

  ngOnDestroy(): void {
  
    if (this._routerCustomerSub !== undefined) {
      this._routerCustomerSub.unsubscribe();
    }
    
    
  }


  fnGetOrder(otype){
    this._selecttabset=otype;
    var data = {
      'ordertype':otype                     
   }
   this.loginservice.fnGetOrderInCustomer(data)
      .subscribe(
        (res)=>{         
          console.log(res.json());        
        if(res.json().status==200){    
          let _result=res.json().result;  
          console.log(_result);     
          this.customerOrderMainColl=_result.ordermain;
          this.customerOrderDetailsColl=_result.orderdetails;          

          for(let wbo of this.customerOrderMainColl){

            wbo.productdetailitem=this.fnSetTotalItemsString(wbo.cartid);
          }
        }        
      },
      (err)=>{          
        this.fnShowErrorMsg('Error'+ err);
      })
  }

  fnOrderTypeBtnClick(type){

    this._ordertype=type;
    this.fnGetOrder(this._ordertype);
      

  }
  
  fnOpenOrderDetilsPopUp(cartid) { 
    var data={
      'doctype':'VIEWORDER',
      'cartid':cartid
    }
    this.emitData.emit(data)
    

    // const modalRef = this.modelService.open(OrdersdetailsComponent, {
    //   size: 'lg', backdropClass: 'light-blue-backdrop', centered: true
    // });
    //  modalRef.componentInstance.cartid =cartid;
    //  modalRef.componentInstance.fnGetOrderDetails()
    // // modalRef.componentInstance.emitData.subscribe((receivedentry) => {
     
    // // });
  }



  fnClose(){
    this.activeModal.close(false);
  }

  
  fnSetTotalItemsString(cartid){
    let _s="";
    let a=0;

    for(let wbo of this.customerOrderDetailsColl){
      if(wbo.cartid===cartid){
        console.log(wbo)
        if(a===2){
          break;
        }
        if(_s===""){
          _s=wbo.productname;
        }
        else{
          _s=_s+","+wbo.productname;
        }
        a+=1;
      }     
    }
    return _s;
  }

  
  private  fnShowErrorMsg(ex){
    console.log(ex);       
  }



}
